export const generateCode = () => {
    const possibleChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let code = "";
    for (let i = 0; i < 32; i++) {
      code += possibleChars.charAt(Math.floor(Math.random() * possibleChars.length));
      if ((i + 1) % 4 === 0 && i !== 31) {
        code += "-";
      }
    }
    return code
}